import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Label } from "~/components-shared";
import styled from "styled-components";
import InputTextControl from "~/components/InputTextControl";
import lists from "~/lib/lists";
import useScopes from "~/hooks/api";
import InputSelectControl from "~/components/InputSelectControl";
const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ApiTokenForm = _ref => {
  let {
    control,
    watch,
    setValue
  } = _ref;
  const {
    t
  } = useTranslation();
  const scopes = useScopes();
  return /*#__PURE__*/React.createElement(Fieldset, null, /*#__PURE__*/React.createElement(InputTextControl, {
    name: "name",
    placeholder: t("ApiTokenForm.mcpToken"),
    label: t("ApiTokenForm.name"),
    control: control,
    s: {
      mb: 4
    },
    required: true
  }), /*#__PURE__*/React.createElement(Label, {
    s: {
      mb: 2
    },
    required: true
  }, t("ApiTokenForm.expiresIn")), /*#__PURE__*/React.createElement(Box, {
    gap: 2,
    s: {
      mb: 4
    }
  }, Object.keys(lists.apiTokens.expiration.names).map(key => /*#__PURE__*/React.createElement(Button, {
    onClick: () => setValue("expiresIn", key),
    fontSize: 3.5,
    color: watch("expiresIn") === key ? "translucentPrimary" : "translucent",
    s: {
      px: 3,
      py: 1
    }
  }, lists.apiTokens.expiration.names[key]))), /*#__PURE__*/React.createElement(InputSelectControl, {
    name: "scopes",
    label: t("ApiTokenForm.scopes"),
    placeholder: t("ApiTokenForm.selectScopes"),
    control: control,
    options: scopes.map(scope => ({
      id: scope,
      value: scope
    })),
    multiple: true,
    withSearch: true,
    fullSelections: true,
    direction: "topLeft",
    required: true
  }));
};
export default ApiTokenForm;